module.exports = __webpack_public_path__ + "img/House2-mobile.be820e86.jpg";